import { useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

// Import redux
import { getServices } from "../../../../redux/features/Settings/Management/Services/index.js";

// Import components
import Loader from "../../../../components/Loader/Index.jsx";
import SVGComponent from "../../../../components/_utils/SVGComponent/index.jsx";
import TitleSubtitlePair from "../../../../components/_utils/TitleSubtitlePair/index.jsx";
import CommonDetailCard from "../../../../components/_utils/CommonDetailCard/index.jsx";
import SwitcherTabs from "../../../../components/_utils/CommonButtons/SwitcherTabs/index.jsx";

//Import utils
import formatDateViewAll from "../../../../utils/formatDateViewAll.js";

const ServiceDetails = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  // switcher tabs states
  const showServiceDetails = true;

  const { services, isLoading } = useSelector((state) => state?.services);

  let serviceDetailsData = services?.services?.[0];

  useEffect(() => {
    const getServiceInfo = async () => {
      try {
        await dispatch(getServices({ service_id: id }));
      } catch (error) {
        console.error(error);
      }
    };
    getServiceInfo();
  }, [dispatch, id]);

  return (
    <div className="flex flex-col overflow-auto bg-primary-bg h-full-height overflow-x-hidden ">
      {!serviceDetailsData && isLoading ? (
        <div className="flex items-center justify-center m-auto">
          <Loader />
        </div>
      ) : serviceDetailsData ? (
        <>
          <div className="hidden Qsmd:block Qsmd:h-navbar-breadcrumb-height bg-primary-nav"></div>
          {/* Responsive page header */}
          <div className="Qsmd:hidden fixed w-width-full p-padding-sm top-top-base bg-primary-nav flex items-center z-z-index-fixed-ui rounded-b-border-radius-md shadow-box-shadow-bottom">
            <div
              className="pl-padding-sm pr-padding-md cursor-pointer"
              onClick={() => navigate(-1)}
            >
              <SVGComponent
                url={
                  "https://q2pay.in/new_assets/common/arrows/arrow_left_white.svg"
                }
                color="var(--text-primary)"
                height={"var(--icon-sm)"}
                width={"var(--icon-sm)"}
              />
            </div>
            <div className="flex flex-col">
              <p className="text-font-md text-text-primary font-normal">
                Service
              </p>
              <p className="text-font-xs text-text-primary font-normal">
                Detail page
              </p>
            </div>
          </div>
          {/* ---------------------- */}
          <div className="w-width-full bg-primary-nav">
            <div className="max-w-tab-width-normal mx-auto Qsmd:px-padding-md Qlg:px-padding-base px-padding-md ">
              <div className="flex flex-col pt-padding-xl mt-margin-md Qsmd:flex-row Qsmd:pt-padding-base Qsmd:mt-margin-base Qsmd:border-b border-solid border-primary-bg">
                <div className="flex-1 py-padding-md Qmd:px-padding-md Qsmd:pl-padding-sm Qsmd:pr-padding-md px-padding-base">
                  <TitleSubtitlePair
                    title={serviceDetailsData?.service_name}
                    subtitle={"Service name"}
                    titleColor={"text-primary"}
                    isBold={false}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
                <div className="border-b Qsmd:border-r border-solid border-primary-bg my-margin-base Qsmd:my-margin-md"></div>
                <div className="flex-1 p-padding-md px-padding-base Qmd:px-padding-md ">
                  <TitleSubtitlePair
                    title={serviceDetailsData?.service_header}
                    subtitle={"Service header"}
                    titleColor={"text-primary"}
                    isBold={false}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
              </div>
              <div className="Qsmd:hidden border-b border-solid border-primary-bg"></div>
              <div className="flex flex-col Qsmd:flex-row Qsmd:pt-padding-base">
                <div className="flex-1 py-padding-md Qmd:px-padding-md Qsmd:pl-padding-sm Qsmd:pr-padding-md">
                  <TitleSubtitlePair
                    title={
                      serviceDetailsData?.is_delete === "N"
                        ? "Active"
                        : "Inactive"
                    }
                    subtitle={"Status"}
                    titleColor={
                      serviceDetailsData?.is_delete === "N"
                        ? "settled"
                        : "failed"
                    }
                    isBold={true}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
                <div className="border-b Qsmd:border-r border-solid border-primary-bg my-margin-base Qsmd:my-margin-md"></div>
                <div className="flex-1 p-padding-md px-padding-base Qmd:px-padding-md">
                  <TitleSubtitlePair
                    title={serviceDetailsData?.privilege || "N/A"}
                    subtitle={"Service privilege"}
                    titleColor={"text-primary"}
                    isBold={false}
                    variant="md"
                    textAlign={"left"}
                  />
                </div>
              </div>
            </div>
          </div>
          {/* Switcher Tab & Additional Details of User */}
          <div className="w-screen">
            <div className="m-auto max-w-tab-width-normal">
              <div className="flex pt-padding-md px-padding-md Qlg:px-padding-base">
                <div className="flex gap-gap-sm bg-primary-card rounded-border-radius-md w-auto Qsm:overflow-x-hidden">
                  <SwitcherTabs
                    tabs={[
                      {
                        label: "Details",
                        key: "details",
                      },
                    ]}
                  />
                </div>
              </div>
              {showServiceDetails ? (
                <div className="flex flex-col Qsmd:flex-row my-margin-md px-padding-md lg:px-padding-base gap-gap-md">
                  <CommonDetailCard
                    cardTitle="Service Description"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Description",
                        content: serviceDetailsData?.service_desc,
                        type: "text",
                      },
                    ]}
                  />

                  <CommonDetailCard
                    cardTitle="Origin Details"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Created by",
                        content: serviceDetailsData?.created_by,
                        type: "text",
                      },
                      {
                        heading: "Created on",
                        content: formatDateViewAll(
                          serviceDetailsData?.created_on,
                          true,
                          true,
                        ),
                        type: "text",
                      },
                    ]}
                  />
                  <CommonDetailCard
                    cardTitle="Support Information"
                    numCols={1}
                    variant="third"
                    entries={[
                      {
                        heading: "Service ID",
                        content: serviceDetailsData?.service_id,
                        type: "text",
                      },
                    ]}
                  />
                </div>
              ) : (
                <></>
              )}
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};

export default ServiceDetails;
